<script lang="ts">
	interface Props {
		textContent: string | Array<string>
		align?: "center" | "left" | "right"
	}

	let { textContent, align = "center" }: Props = $props()
</script>

<p class={`paragraph para-${align}`}>
	{#if typeof textContent === "string"}
		{@html textContent}
	{:else}
		{#each textContent as text}
			<span>{@html text}</span>
		{/each}
	{/if}
</p>

<style>
	p.para-center {
		text-align: center;
	}

	p.para-left {
		text-align: left;
	}

	p.para-right {
		text-align: right;
	}

	span {
		display: block;
	}
</style>
